import React, { useState, useContext } from "react";
import { useParams, withRouter } from "react-router-dom";
import { css } from "emotion";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import workspaces from "../../services/api/workspaces";
import { GlobalContext } from "../../context/GlobalState";
import ErrorMessage from "../ErrorMessage";
import { colors } from "../../styles/theme";
import GenericButton from "../GenericButton";
import BillingTitle from "../billing/BillingTitle";

const CheckoutForm = ({ history }) => {
  const { currentWorkspace, setCurrentPlan } = useContext(GlobalContext);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const stripe = useStripe();
  const elements = useElements();
  const { planId } = useParams();
  const coupon = sessionStorage.getItem("coupon");
  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: colors.cancel,
        iconColor: colors.cancel,
      },
    },
  };
  const handleChange = (event) => {
    if (event.error) {
      setError(event.error.message);
    } else {
      setError(null);
    }
  };
  const handleSubmit = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);
    if (result.error) {
      // Inform the user if there was an error.
      setError(result.error.message);
      setIsLoading(false);
    } else {
      setError(null);
      // Send the token to our server.
      const { token } = result;
      const paymentMethodData = {
        workspace: currentWorkspace.id,
        stripeToken: token.id,
      };
      try {
        await workspaces.addPaymentMethod(paymentMethodData);
        let subscriptionData = {
          workspace: currentWorkspace.id,
          planId,
        };
        const { data } = await workspaces.updateSubscription(subscriptionData);
        if (data) {
          console.log(data);
          const paymentSource = data.customer.default_source;
          const clientSecret = data.clientSecret;
          const { paymentIntent, error } = await stripe.confirmCardPayment(
            clientSecret,
            {
              payment_method: paymentSource,
            }
          );
          if (error) {
            console.log(error);
          }
        }

        if (coupon) {
          subscriptionData.coupon = coupon;
        }

        setCurrentPlan(planId);
        history.push("/home");
      } catch (error) {
        setError(
          "We were unable to add your payment method. Please reload your page and try again."
        );
        console.log("ERROR", error);
        setIsLoading(false);
      }
    }
  };
  return (
    <form onSubmit={handleSubmit} className={container}>
      <div className="form-row">
        <BillingTitle title="Add Payment Method" />
        <CardElement
          id="card-element"
          options={CARD_ELEMENT_OPTIONS}
          onChange={handleChange}
        />
        <div className="card-errors" role="alert">
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </div>
      </div>
      <div className="button-container">
        <GenericButton text="Confirm Order" disabled={isLoading} />
      </div>
    </form>
  );
};
export default withRouter(CheckoutForm);
const container = css`
  margin: 10px auto 0;
  align-self: center;
  h4 {
    margin-bottom: 20px;
  }
  .card-errors {
    padding: 5px 0 12px;
  }
  .button-container {
    margin: 30px auto 0;
    max-width: 240px;
    width: 100%;
  }
  .StripeElement {
    height: 40px;
    padding: 10px 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    background-color: ${colors.inputBackground};
    box-shadow: 0 1px 3px 0 #e6ebf1;
    transition: box-shadow 150ms ease;
  }
  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }
  .StripeElement--invalid {
    border-color: #fa755a;
  }
  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
`;
